import { Component, OnInit } from "@angular/core";
import _ from "lodash";
import * as moment from "moment";
import { HouseStatusSettingService } from "@root/router/setting/custom-config/house-status-setting.service";
import { OrderV2Service } from "@root/router/order-v2/order-v2.service";
import { TranslateService } from "@root/shared/service/translate.service";

@Component({
  selector: "host-house-today",
  templateUrl: "./house-today.component.html",
  styleUrls: ["./house-today.component.scss"],
})
export class HouseTodayComponent implements OnInit {
  todayAddList = [];
  todayAddTotal = 0;
  todayAddPage = 1;
  checkInList = [];
  checkInTotal = 0;
  checkInPage = 1;
  checkOutList = [];
  checkOutTotal = 0;
  checkOutPage = 1;
  channels = [];
  currentLang = this.translateService.getCurrentLang();
  pageSize = 20;

  constructor(
    private orderService: OrderV2Service,
    private houseStatusSettingService: HouseStatusSettingService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    // this.getdetail();
    // this.getOptions();
  }
  getdetail() {
    this.getTodayAdd();
    this.getCheckIn();
    this.getCheckOut();
  }

  getOptions() {
    this.houseStatusSettingService.getSettings().subscribe((res) => {
      if (res.error_code === 0) {
        this.channels = _.get(res, "data.reservation_channel");
      }
    });
  }

  getTodayAdd() {
    const params = {
      page: this.todayAddPage,
      page_size: this.pageSize,
      version: 1,
    };
    this.orderService.todayAddReservation(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.todayAddList = res.data.list;
        this.todayAddTotal = res.data.count;
      }
    });
  }

  getCheckIn() {
    const params = {
      page: this.checkInPage,
      page_size: this.pageSize,
      check_in: moment().format("YYYY-MM-DD"),
      format: "split_by_reservation",
    };
    this.orderService.getReservationOrderList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.checkInList = _.get(res, "data.list");
        this.checkInTotal = _.get(res, "data.count");
      }
    });
  }

  getCheckOut() {
    const params = {
      page: this.checkOutPage,
      page_size: this.pageSize,
      check_out: moment().format("YYYY-MM-DD"),
      format: "split_by_reservation",
    };
    this.orderService.getReservationOrderList(params).subscribe((res) => {
      if (res.error_code === 0) {
        this.checkOutList = _.get(res, "data.list");
        this.checkOutTotal = _.get(res, "data.count");
      }
    });
  }

  refresh(e) {
    if (e) {
      this.getTodayAdd();
      this.getCheckIn();
      this.getCheckOut();
    }
  }

  pageChanged(params, e) {
    switch (params) {
      case 0:
        this.todayAddPage = e;
        this.getTodayAdd();
        break;
      case 1:
        this.checkInPage = e;
        this.getCheckIn();
        break;
      case 2:
        this.checkOutPage = e;
        this.getCheckOut();
    }
  }
}
